import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import search from '@/components/search/index.vue';
import pagination from '@/components/pagination/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';
import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

import {
  DEFAULT_IMAGE,
  ROLE_PROOF_READER,
  ROLE_QA_EXPERT,
  JOB_STATUS_PREPARATION,
} from '@/utils/const';

export default {
  props: {
    job: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [
    helpers.work_with_date,
  ],
  components: {
    Multiselect,
    DatePicker,
    Treeselect,
    pagination,
    preloader,
    empty,
    search,
  },
  data () {
    return {
      executorsData: [],
      responseData: {},

      defaultImage: DEFAULT_IMAGE,
      params: {
        available: false,
        sourceLanguage: '',
        targetLanguage: '',
        searchRow: '',
        documentTypes: null,
        industrySectors: null,
        fieldName: '',
        company: null,
        order: '',
        accountTypeSlug: ROLE_PROOF_READER,
        dueDate: '',
        page: 1,
        ppage: 15,
      },

      filterData: {
        source_language: [],
        target_language: [],
        industry: [],
        document_type: [],
        company: [],
        due_date: '',
      },

      selectAllExecutors: false,
      sortByName: '',
      sortBy: '',
      filterTab: 0,

      jobstatusPreparation: JOB_STATUS_PREPARATION,
      load: true,
    };
  },
  computed: {
    checkSelectExecutors () {
      return this.executorsData.find((item) => item.Selected === true);
    },
    executorsDataSelected () {
      return this.executorsData.filter((item) => item.Selected === true);
    },
  },
  created () {
    this.getExecutors();
    this.getFilters();
  },
  methods: {
    /**
         * Method return string for multiselect
         *
         * @param {Number} count
         */
    limitText (count) {
      return `and ${count} others manager`;
    },

    /**
         * Set accoount slug for params
         */
    setAccountTypeSlug () {
      this.params.accountTypeSlug = this.job.JobTypeData.JobTypeName === this.jobstatusPreparation
        ? ROLE_PROOF_READER : ROLE_QA_EXPERT;
    },

    /**
         * Get executors for job (proofreaders / qaexperts)
         */
    getExecutors () {
      this.load = true;

      Api.user
        .getExecutors(this.transformParams())
        .then((response) => {
          if (response.data.Status) {
            this.executorsData = response.data.Data;
            this.selectAllExecutors = this.executorsData.find((item) => item.Selected) !== undefined;
            this.responseData = response.data;
          }
          this.load = false;
        });
    },

    /**
         * Select all executor
         */
    selectAll () {
      this.selectAllExecutors = !this.selectAllExecutors;
      this.executorsData.forEach((item) => {
        item.Selected = this.selectAllExecutors;
      });
    },

    /**
         * Disable executor
         */
    unselectExecutor (id) {
      const item = this.executorsData.find((item) => item.UserId === id);
      item.Selected = !item.Selected;
      if (!this.executorsData.find((item) => item.Selected)) {
        this.selectAllExecutors = false;
      }
    },

    /**
         * Handle params
         */
    transformParams () {
      this.setAccountTypeSlug();

      const request = {
        id: this.job.ChildJob == null ? this.$route.params.id : this.job.ChildJob,
        params: {
          ...this.params,
          sourceLanguage: this.params.sourceLanguage ? this.params.sourceLanguage.ID : this.job.SourceLanguageID,
          targetLanguage: this.params.targetLanguage ? this.params.targetLanguage.ID : this.job.TargetLanguageID,
          documentTypes: this.params.documentTypes ? this.params.documentTypes.ID : '',
        },
      };

      return request;
    },

    /**
         * Pagination
         *
         * @param {Number} page
         */
    sendPage (page) {
      this.params.page = page;
      this.getExecutors();
    },

    /**
         * Reset all filters
         */
    resetFilters () {
      this.params = {
        available: false,
        sourceLanguage: '',
        targetLanguage: '',
        searchRow: '',
        documentTypes: null,
        industrySectors: null,
        fieldName: '',
        company: null,
        order: '',
        accountTypeSlug: this.params.accountTypeSlug,
        dueDate: '',
        page: 1,
        ppage: 15,
      };
      this.getExecutors();
    },

    /**
         * Method for set field search oi params
         */
    holderSearch (searchString) {
      this.params.searchRow = searchString;
      this.getExecutors();
    },

    /**
         * Method for set field search oi params
         */
    holderSearchInput (searchString) {
      this.params.searchRow = searchString;
    },

    /**
         * Get filters for job
         */
    getFilters () {
      this.getJobLanguage();
      this.getIndustry();
      this.getDocumentType();
    },

    /**
         * Get current languages
         */
    getJobLanguage () {
      const params = {
        SourceLanguage: this.job.SourceLanguageID,
        TargetLanguage: this.job.TargetLanguageID,
      };

      Api.jobs
        .getJobLanguages(params)
        .then((response) => {
          if (response.data.Status) {
            this.filterData.source_language = response.data.Data.SourceLanguages;
            this.filterData.target_language = response.data.Data.TargetLanguages;
          }
        });
    },

    /**
         * Get all industry sectors
        */
    getIndustry () {
      Api.registration
        .getThreeData()
        .then((response) => {
          if (response.status === 200) {
            this.filterData.industry = response.data;
          }
        });
    },

    /**
         * Get all document types
         */
    getDocumentType () {
      Api.dashboard
        .getDocType()
        .then((response) => {
          if (response.data.Status) {
            this.filterData.document_type = response.data.Data;
          }
        });
    },

    sendExecutors () {
      const executors = this.executorsData.filter((item) => item.Selected).map((item) => {
        return {
          ExecutorId: item.UserId,
          Email: item.Email,
          FirstName: item.FirstName,
          LastName: item.LastName,
        };
      });

      const params = {
        'jobId': this.job.ChildJob == null ? this.job.ID : this.job.ChildJob,
        'jobType': this.job.JobTypeData.JobTypeName === 'Evaluation' && this.job.JobTypeData.JobStatusName === 'Ready' ? 'Validation' : '',
        'executorsList': executors,
      };

      Api.jobs
        .setExecutors(params)
        .then((response) => {
          if (response.data.Status) {
            this.getExecutors();

            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'info',
              show: true,
            });

            this.$emit('hide');
            this.$emit('refreshJob');
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },
  },
};
